var React = require('react');

function ModalClose (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Plus","transform":"translate(954.241 -1391.233) rotate(45)"},[React.createElement("line",{"id":"Line_7","data-name":"Line 7","y2":"24","transform":"translate(322 1646.5)","fill":"none","stroke":"#fff","strokeWidth":"2","key":0}),React.createElement("line",{"id":"Line_8","data-name":"Line 8","y2":"24","transform":"translate(334 1658.5) rotate(90)","fill":"none","stroke":"#fff","strokeWidth":"2","key":1})]));
}

ModalClose.defaultProps = {"width":"18.385","height":"18.385","viewBox":"0 0 18.385 18.385"};

module.exports = ModalClose;

ModalClose.default = ModalClose;
